import { useCurrentMarketplaceStore } from '../stores/currentMarketplaceStore';

export const useCurrentMarketplace = () => {
  const currentMarketplace = useCurrentMarketplaceStore(
    (state) => state.currentMarketplace
  );
  const setCurrentMarketplace = useCurrentMarketplaceStore(
    (state) => state.setCurrentMarketplace
  );
  const updateCurrentMarketplace = useCurrentMarketplaceStore(
    (state) => state.updateCurrentMarketplace
  );
  const clearCurrentMarketplace = useCurrentMarketplaceStore(
    (state) => state.clearCurrentMarketplace
  );
  const isLoaded = useCurrentMarketplaceStore((state) =>
    state.isCurrentMarketplaceLoaded()
  );

  return {
    currentMarketplace,
    isLoaded,
    setCurrentMarketplace,
    updateCurrentMarketplace,
    clearCurrentMarketplace,
  };
};
